import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class DescriptionsViewModel {
    BackToSignIn:           () => void;
    NewLoading:             (pMessage: string) => dmLoading;
                            
    mlText:                 MLText;
    app:                    mlBroker;
    ml:                     mlBroker;
    Hotel:                  dmHotel;
    LangID:                 number;
                            
    Languages:              RQService.Pms.GetLanguagesRow[];
    Descriptions:           RQService.Ota.GetHotelDescriptionsRow[];

    DescriptionLangID:      number;
    RouteDescriptionLangID: number;

    Description:            string;
    RouteDescription:       string;

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: () => void
        ,pNewLoading:   (pMessage: string) => dmLoading
    ) {
        this.mlText                 = pMLText;
        this.LangID                 = this.mlText.GetLangID();
        this.app                    = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                     = this.mlText.GetBroker(
            'HotelAreaDescriptions'
        );

        this.Hotel                  = pHotel;
        this.BackToSignIn           = pBackToSignIn;
        this.NewLoading             = pNewLoading;

        this.Languages              = [];
        this.Descriptions           = [];

        this.DescriptionLangID      = 1;
        this.RouteDescriptionLangID = 1;

        this.Description            = '';
        this.RouteDescription       = '';

        this.setLanguagesHandler();
        this.setDescriptionsHandler();

        this.PopulateLanguages(() => {
            this.PopulateDescriptions();
        });
    }

    private setLanguagesHandler(): void {
        RQHandlers.Pms.GetLanguages = (result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let languages = response.RQueryResult;

            this.Languages.length = 0;

            for (let i = 0; i < languages.length; i++) {
                let language = RQService.Pms.PopulateGetLanguagesRow(
                    languages[i]
                );

                console.log('row push');

                this.Languages.push(language);
            }
        };
    }

    private setDescriptionsHandler(): void {
        RQHandlers.Ota.GetHotelDescriptions = (result) => {
            let response = result as any;

            if (response.HasErrorOrException) { return; }

            let descriptions = response.RQueryResult;

            this.Descriptions.length = 0;

            for (let i = 0; i < descriptions.length; i++) {
                let description = RQService.Ota.PopulateGetHotelDescriptionsRow(
                    descriptions[i]
                );

                console.log('row push');

                this.Descriptions.push(description);
            }
        };
    }

    public PopulateLanguages(pAction: () => void): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark' ,'Loading...')
        );

        loading.Show(() => {
            RQService.Pms.GetLanguages(
                {}
            ).then((result) => {
                loading.Dismiss();
            
                pAction();
            });
        });
    }

    public PopulateDescriptions() {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark' ,'Loading...')
        );

        loading.Show(() => {
            let descriptionsParams     = RQParam.OtaGetHotelDescriptionsParams();
            
            descriptionsParams.HotelID = this.Hotel.HotelID;
            
            RQService.Ota.GetHotelDescriptions(
                descriptionsParams
            ).then((result) => {
                this.Description       = this.Descriptions[
                    (this.DescriptionLangID      - 1)
                ].Description;
            
                this.RouteDescription  = this.Descriptions[
                    (this.RouteDescriptionLangID - 1)
                ].RouteDescription;
            
                loading.Dismiss();
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }

    public ChangeDescriptionLangID(pLangID: number) {
        this.DescriptionLangID = pLangID;

        this.Description = this.Descriptions[
            (this.DescriptionLangID - 1)
        ].Description;
    }

    public ChangeRouteDescriptionLangID(pLangID: number) {
        this.RouteDescriptionLangID = pLangID;

        this.RouteDescription = this.Descriptions[
            (this.RouteDescriptionLangID - 1)
        ].RouteDescription;
    }

    public SaveDescription(): void {
        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let saveParams = RQParam.OtaEditHotelDescriptionParams();
            
            saveParams.HotelID     = this.Hotel.HotelID;
            saveParams.Description = this.Description.trim();
            saveParams.LangID      = this.DescriptionLangID;
            
            RQService.Ota.EditHotelDescription(saveParams).then((result) => {
                this.Descriptions[
                    (this.DescriptionLangID - 1)
                ].Description = this.Description.trim();
            
                loading.Dismiss();
            });
        });
    }

    public SaveRouteDescription(): void {
        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let saveParams = RQParam.OtaEditHotelRouteDescriptionParams();
            
            saveParams.HotelID          = this.Hotel.HotelID;
            saveParams.RouteDescription = this.RouteDescription.trim();
            saveParams.LangID           = this.LangID;

            RQService.Ota.EditHotelRouteDescription(saveParams).then((result) => {
                this.Descriptions[
                    (this.RouteDescriptionLangID - 1)
                ].RouteDescription = this.RouteDescription.trim();
            
                loading.Dismiss();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/descriptions/xv-descriptions.ts